"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

interface CompetitionContextProps {
  // session: any; // Replace `any` with your session type
  brand: string;
  competitionConfig: any; // Use the actual type of your competitionConfig
  competitionData: any; // Use the actual type of your competitionData
  weekId: number;
  setWeekId: (weekId: number) => void;
}

export const CompetitionContext = createContext<CompetitionContextProps | null>(null);

interface CompetitionProviderProps {
  // session: any; // Replace `any` with the correct type
  brand: string;
  competitionConfig: any;
  competitionData: any; // Replace `any` with the correct type
  children: ReactNode;
}

export const CompetitionProvider = ({ brand, competitionConfig, competitionData, children }: CompetitionProviderProps) => {
  const [weekId, setWeekId] = useState(0);

  return (
    <CompetitionContext.Provider value={{ brand, competitionConfig, competitionData, weekId, setWeekId }}>
      {children}
    </CompetitionContext.Provider>
  );
};

export const useCompetitionContext = () => {
  const context = useContext(CompetitionContext);
  if (!context) {
    throw new Error("useCompetitionContext must be used within an CompetitionProvider");
  }
  return context;
};
